import classNames from 'classnames';
import { memo } from 'react';

import { Flex } from '@/lib/v2/components';
import InsightCard, { InsightCardProps } from '@/lib/v2/organisms/InsightCard/InsightCard';

export interface MessageCardsListProps {
  /** list cards filter */
  cardsList: InsightCardProps[];
}

const MessageCardsList = ({ cardsList }: MessageCardsListProps) => {
  const classes = classNames('flex flex-col gap-3 lg:gap-6 w-full mx-auto xl:w-auto min-w-0 px-10');

  return (
    <Flex alignment="center">
      <div className={classes}>
        {cardsList.map((item) => {
          const { ...restOfProps } = item;
          return (
            <InsightCard
              key={item.title}
              fullText
              hasSpacing
              titleColor={'primary'}
              {...restOfProps}
              isLoading={false}
            />
          );
        })}
      </div>
    </Flex>
  );
};

export default memo(MessageCardsList);
